// extracted by mini-css-extract-plugin
module.exports = {"container":"NEfGcb3m5os3A3CYIzIqg"};